export const BASE_ROUTE = "/";

export const PROFILE_ROUTE = "/profile";
export const SETTINGS_NOTIFICATIONS_ROUTE = "/settings/notifications";
export const SETTINGS_SECURITY_ROUTE = "/settings/security";

export const TODAYS_ACTIONS_ROUTE = "/dashboard/tasks/actions";
export const MY_DAILY_ACTIONS_ROUTE = "/todays-actions";
export const PRODUCTION_SCHEDULE_ROUTE = "/dashboard/production-schedule";
export const PROJECT_TABLE_ROUTE = "/dashboard";
export const PROJECT_TABLE_V2_ROUTE = "/dashboard/projectsv2";
export const TASK_TABLE_ROUTE = "/dashboard/tasks";
export const TASK_TABLE_V2_ROUTE = "/dashboard/tasksv2";
export const BID_TABLE_ROUTE = "/dashboard/bids";
export const SALES_VISIT_ROUTE = "/sales";
export const MY_ORGANIZATION_ROUTE = "/dashboard/my-organization";
export const CONTRACTOR_TABLE_ROUTE = "/contractors";
export const RECRUITING_ROUTE = "/recruiting";
export const CONTRACTOR_DASHBOARD_ROUTE = "/dashboard/today";
export const TRAINING_ROUTE = "/training";
export const FINANCIAL_CONSOLE_ROUTE = "/finance/pricebook";
export const REMITTANCE_ROUTE = "/remittance";
export const INBOX_ROUTE = "/inbox/my-inbox";
export const MY_QUEUE_ROUTE = "/my-queue";
export const NOTIFICATIONS_ROUTE = "/notifications";

export type InboxItemType = "ticket" | "conversation" | "task" | "escalation";

export const inboxViewHref = (view: string, options?: { viewId?: string; teamId?: string }): string => {
  const base = `/inbox/${encodeURIComponent(view)}`;
  const search = new URLSearchParams();
  if (options?.viewId) {
    search.set("viewId", options.viewId);
  }
  if (options?.teamId) {
    search.set("teamId", options.teamId);
  }
  const query = search.toString();
  return query ? `${base}?${query}` : base;
};

export const inboxItemHref = (args: {
  view: string;
  type: InboxItemType;
  id: string;
  conversationId?: string;
  viewId?: string;
}): string => {
  const { view, type, id, conversationId, viewId } = args;
  const v = encodeURIComponent(view);
  const itemId = encodeURIComponent(id);
  const base =
    type === "task" && conversationId
      ? `/inbox/${v}/task/${itemId}/conversation/${encodeURIComponent(conversationId)}`
      : `/inbox/${v}/${type}/${itemId}`;
  return viewId ? `${base}?viewId=${encodeURIComponent(viewId)}` : base;
};

export const LIVE_PHOTO_REVIEW_ROUTE = "/live-photo-review";
export const WESTHILL_XA_EVENTS_ROUTE = "/westhill-xa-events";

export const livePhotoReviewSubmissionHref = (submissionId: string): string =>
  `${LIVE_PHOTO_REVIEW_ROUTE}?submissionId=${encodeURIComponent(submissionId)}`;

export const PROJECT_INFO_TAB_PARAM = "info";
export const PROJECT_INFO_PHOTOS_TAB = "photos";

export const projectPhotosHref = (projectId: number): string =>
  `/dashboard/${projectId}?${PROJECT_INFO_TAB_PARAM}=${PROJECT_INFO_PHOTOS_TAB}`;

export const ADMIN_TEAM_MEMBERS_ROUTE = "/admin/team-members";

export const ADMIN_OC_REGION_MANAGEMENT_ROUTE = "/admin/oc-region-management";
export const ADMIN_RLL_REGION_MANAGEMENT_ROUTE = "/admin/rll-region-management";
export const ADMIN_REGION_DETAILS_ROUTE = "/admin/region-details";
export const ADMIN_ROUTE = "/admin";
export const TRAINING_CONTRACTORS_ROUTE = "/admin/training-contractors";
export const QUOTE_ROUTE = "/quote/bid";
export const PROJECT_MILESTONES_ROUTE = "/dashboard/project-milestones";
export const VOLUME_ROUTE = "/dashboard/volume";
export const DEVELOPER_PORTAL_ROUTE = "/developer-portal";
export const CONTRACTOR_ONBOARDING_ROUTE = "/contractors/onboarding";
export const CONTRACTOR_TRAINING_ROUTE = "/contractors/training";

export const DEVTOOLS_ROUTE = "/devtools";
export const DISPATCH_ROUTE = "/dispatch";

export const VIEW_TODAYS_ACTIONS_ROUTE = "/dashboard/tasks/actions";
export const VIEW_PRODUCTION_SCHEDULE_ROUTE = "/dashboard/production-schedule";
export const VIEW_MY_TASKS_ROUTE = "/dashboard/tasks?view=my-tasks";
export const VIEW_CORRECTIONS_ROUTE = "/dashboard/tasks?view=corrections";
export const VIEW_PARTNER_SUCCESS_TASKS_ROUTE = "/dashboard/tasks?view=partner-success-tasks";
export const VIEW_APPEASEMENTS_ROUTE = "/dashboard/tasks?view=appeasement-tasks";
export const VIEW_VENDOR_CREDITS_ROUTE = "/dashboard/tasks?view=vendor-credit-tasks";
export const VIEW_CONCESSION_APPROVALS_ROUTE = "/dashboard/tasks?view=concession-approvals";
export const VIEW_ITEL_TASKS_ROUTE = "/dashboard/tasks?view=itel-tasks";
export const VIEW_OPERATIONS_COORDINATOR_ROUTE = "/dashboard/tasks?view=operations-coordinator";
export const VIEW_STANDARD_QUOTING_ROUTE = "/dashboard/tasks?view=standard-quoting";
export const VIEW_INSURANCE_QUOTING_ROUTE = "/dashboard/tasks?view=insurance-quoting";
export const VIEW_LIVE_QUOTING_ROUTE = "/dashboard/tasks?view=live-quoting";
export const VIEW_QUOTE_REVIEW_ROUTE = "/dashboard/tasks?view=quote-review";
export const VIEW_INTRO_CALL_ROUTE = "/dashboard/tasks?view=intro-call";
export const VIEW_PRE_PRODUCTION_ROUTE = "/dashboard/tasks?view=pre-production";
export const VIEW_CONTRACTOR_PRODUCTION_ROUTE = "/dashboard/tasks?view=contractor-production";
export const VIEW_FINAL_CHECK_OFF_ROUTE = "/dashboard/tasks?view=finalCheckOff";
export const VIEW_FINANCE_ROUTE = "/dashboard/tasks?view=finance";
export const VIEW_PERMITTING_ROUTE = "/dashboard/tasks?view=permitting";
export const VIEW_CHANGE_ORDERS_ROUTE = "/dashboard/tasks?view=change-orders-submission";
export const VIEW_POST_INSTALL_ISSUES_ROUTE = "/dashboard/tasks?view=post-install-issues";
export const VIEW_BLOCKING_TASKS_ROUTE = "/dashboard/tasks?view=blocking-tasks";
export const VIEW_UPSELL_QUOTING_ROUTE = "/dashboard/tasks?view=upsell-quoting";
export const VIEW_UPSELLS_ROUTE = "/dashboard/tasks?view=upsells";
export const VIEW_REVIEW_FINANCIAL_ADJUSTMENTS_ROUTE = "/dashboard/tasks?view=review-financial-adjustments";
export const VIEW_CONTRACTOR_DOCUMENTS_ROUTE = "/dashboard/tasks?view=contractor-documents";
export const VIEW_REVIEW_BIDS_ROUTE = "/dashboard/tasks?view=review-bids";
export const VIEW_REMI_LABOR_ROUTE = "/dashboard/tasks?view=remi-labor";
export const VIEW_INSURANCE_ALL_ASSIGNMENTS_ROUTE = "/dashboard/insurance?view=all-assignments";
export const VIEW_INSURANCE_MY_ASSIGNMENTS_ROUTE = "/dashboard/insurance?view=my-assignments";
export const VIEW_INSURANCE_ORG_ASSIGNMENTS_ROUTE = "/dashboard/insurance?view=org-assignments";
export const VIEW_INSURANCE_MY_ASSIGNMENTS_PENDING_ESTIMATE_ROUTE =
  "/dashboard/insurance?view=my-assignments-pending-estimate";
export const VIEW_INSURANCE_MY_ASSIGNMENTS_JOB_COMPLETED_ROUTE =
  "/dashboard/insurance?view=my-assignments-job-completed";
export const VIEW_INSURANCE_MY_ASSIGNMENTS_JOB_NOT_SOLD_ROUTE = "/dashboard/insurance?view=my-assignments-job-not-sold";
export const VIEW_INSURANCE_MY_ASSIGNMENTS_JOB_SOLD_ROUTE = "/dashboard/insurance?view=my-assignments-job-sold";
export const VIEW_INSURANCE_MY_ASSIGNMENTS_JOB_STARTED_ROUTE = "/dashboard/insurance?view=my-assignments-job-started";
export const VIEW_INSURANCE_MY_ASSIGNMENTS_COMP_ESTIMATES_ROUTE =
  "/dashboard/insurance?view=my-assignments-comp-estimates";
export const VIEW_INSURANCE_MY_ASSIGNMENTS_CANCELED_ROUTE = "/dashboard/insurance?view=my-assignments-canceled";
export const VIEW_INSURANCE_MY_ASSIGNMENTS_APPROVED_ROUTE = "/dashboard/insurance?view=my-assignments-approved";
export const VIEW_INSURANCE_MY_ASSIGNMENTS_CORRECTIONS_REQUESTED_ROUTE =
  "/dashboard/insurance?view=my-assignments-corrections-requested";
export const VIEW_INSURANCE_MY_ASSIGNMENTS_PENDING_APPROVAL_ROUTE =
  "/dashboard/insurance?view=my-assignments-pending-approval";
export const VIEW_ESTIMATING_ROUTE = "/dashboard/tasks?view=estimating";
export const VIEW_ESTIMATING_APPROVALS_ROUTE = "/dashboard/tasks?view=estimating-approvals";
export const VIEW_MY_ESTIMATING_TASKS_ROUTE = "/dashboard/tasks?view=my-estimating-tasks";
export const VIEW_MY_BLOCKING_TASKS_ROUTE = "/dashboard/tasks?view=my-blocking-tasks";
export const VIEW_MY_WESTHILL_TASKS_ROUTE = "/dashboard/tasks?view=my-westhill-tasks";
export const VIEW_UNASSIGNED_WESTHILL_TASKS_ROUTE = "/dashboard/tasks?view=unassigned-westhill-tasks";
export const VIEW_MY_OPENLY_TASKS_ROUTE = "/dashboard/tasks?view=my-openly-tasks";
export const VIEW_UNASSIGNED_OPENLY_TASKS_ROUTE = "/dashboard/tasks?view=unassigned-openly-tasks";
export const INSURANCE_BID_REQUEST_ROUTE = "/dashboard/insurance";
export const VIEW_1099_ESTIMATING_ROUTE = "/dashboard/tasks?view=1099-estimating";

export const VIEW_INGESTION_REVIEW_ROUTE = "/dashboard/actionables?view=ingestion-review";
export const CONVERSATION_DETAILS_ROUTE = "/conversations/details";
export const TICKET_DETAILS_ROUTE = "/tickets/details";
export const ESCALATION_TABLE_ROUTE = "/dashboard/escalations";
export const VIEW_TRAVELERS_CLEANUP_ROUTE = "/dashboard/travelers-cleanup";
export const escalationDetailRoute = (escalationId: string): string => `/dashboard/escalations/${escalationId}`;
export const ticketDetailRoute = (ticketId: string): string => `/tickets/details/${ticketId}`;
export const conversationDetailRoute = (conversationId: string): string => `/conversations/details/${conversationId}`;
export const UNAUTHORIZED_ROUTE = "/unauthorized";

export const publicPaths = [
  "/amfam/scope-of-work",
  "/customer-feedback",
  "/sign-up",
  "/sign-in",
  "/privacy-policy",
  "/support",
  "/mobile/download",
  "/mobile/link",
  "/.well-known",
  "/mfa/setup",
];
